<nz-avatar
  nzIcon="user"
  [nzSize]="size"
  [nzSrc]="'https://gravatar.com/avatar/' + model.emailHash.toLowerCase() + '?d=identicon'"
></nz-avatar>
